import { Column } from "@/components/common/Table";
import { TruncatedTableCell } from "@/components/common/TruncatedTableCell";

export const columns: Column<Immunization>[] = [
  {
    key: "vaccine",
    label: "Vaccines",
    isSortable: false,
    cellClassName: "w-[250px] min-w-[250px] max-w-[250px]",
    headerClassName: "w-[250px] min-w-[250px] max-w-[250px]",
    render: (row) => (
      <TruncatedTableCell
        content={row.vaccine || "-"}
        className='text-grey-800 dark:text-white'
      />
    ),
  },
  {
    key: "lastDose",
    label: "Last Dose",
    isSortable: false,
    cellClassName: "w-[120px] min-w-[120px]",
    headerClassName: "w-[120px] min-w-[120px]",
    render: (row) => (
      <TruncatedTableCell
        content={row.lastDose || "-"}
        className='text-grey-800 dark:text-white'
      />
    ),
  },
];